import { Editor, Element as SlateElement, Transforms } from 'slate'

import { isFirstChildSelectedHelper } from 'core-components/library/richTextEditor/helpers/isFirstChildSelectedHelper'
import { decreaseListLevel } from 'core-components/library/richTextEditor/helpers/listHelpers/decreaseListLevel'
import { increaseListLevel } from 'core-components/library/richTextEditor/helpers/listHelpers/increaseListLevel'
import { isList } from 'core-components/library/richTextEditor/helpers/listHelpers/isListHelper'
import { listsNodeHelper } from 'core-components/library/richTextEditor/helpers/listsHelper'
import { CustomEditor } from 'core-components/library/richTextEditor/interface/custom-types'

const DEFAULT_INDENT = 25

const updateIndent = (
  editor: CustomEditor,
  calculateNewIndent: (marginLeftValue: number) => string | undefined
) => {
  if (!editor.selection) {
    return
  }
  const [generalNode] = Editor.nodes(editor, {
    match: (node) => SlateElement.isElement(node),
    at: [editor.selection.anchor.path[0]],
  })

  if (generalNode && SlateElement.isElement(generalNode[0])) {
    const marginLeftValue = generalNode[0]['marginLeft']
      ? parseInt(generalNode[0]['marginLeft'], 10)
      : 0

    const newIndent = calculateNewIndent(marginLeftValue)

    Transforms.setNodes(
      editor,
      {
        marginLeft: newIndent,
      },
      { at: [editor.selection.anchor.path[0]] }
    )
  }
}

export const increaseIndent = (editor: CustomEditor) => {
  if (!editor.selection) {
    return
  }

  const isInList = !!Editor.above(editor, { match: isList })
  const { listFormat } = listsNodeHelper(editor, editor.selection)
  const isFirstChildSelected = isFirstChildSelectedHelper(editor)

  if (isInList && listFormat && !isFirstChildSelected) {
    increaseListLevel(editor, listFormat)

    return
  }

  updateIndent(editor, (marginLeftValue: number) => {
    return `${marginLeftValue + DEFAULT_INDENT}px`
  })
}

export const decreaseIndent = (editor: CustomEditor) => {
  const isInList = !!Editor.above(editor, { match: isList })
  const isFirstChildSelected = isFirstChildSelectedHelper(editor)

  if (isInList && !isFirstChildSelected) {
    decreaseListLevel(editor)

    return
  }

  updateIndent(editor, (marginLeftValue: number) => {
    return marginLeftValue > DEFAULT_INDENT ? `${marginLeftValue - DEFAULT_INDENT}px` : undefined
  })
}
